// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3EzEA","selects":"Documents_selects__GFKsy"};